import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePrefsRequest } from '../redux/prefs/prefsSlice';
import { DEFAULT_RESIDENCY } from '../constants/default';

const useResidencyPreselection = () => {
  const dispatch = useDispatch();
  const residency = useSelector(state => state.prefs.residency);

  useEffect(() => {
    // Only fetch if residency is not already set
    if (residency) {
      return;
    }

    const fetchResidency = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (response.ok) {
          const data = await response.json();
          if (data.country_code) {
            dispatch(updatePrefsRequest({ residency: data.country_code }));
            return;
          }
        }
      } catch (error) {
        console.log('Failed to fetch IP for residency:', error);
      }
      // If fetch failed or no country_code, set default
      dispatch(updatePrefsRequest({ residency: DEFAULT_RESIDENCY }));
    };
    fetchResidency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount
};

export default useResidencyPreselection;